import {
  Box,
  Button,
  List,
  TextField,
  Typography,
  Paper,
  Stack,
} from '@mui/material'
import CategoryIcon from '@mui/icons-material/LocalOffer'
import ClearIcon from '@mui/icons-material/Clear'
import EventIcon from '@mui/icons-material/Event'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import React from 'react'
import { useEntryContext } from './EntryContext'
import { CategoryItem } from '../category'
import { matchPath, useLocation } from 'react-router-dom'
import { EntryEdit } from './EntryEdit'
export const EntryFilterSidebar = () => {
  const { categories, entryFilter, setEntryFilter } = useEntryContext()
  const location = useLocation()
  const match = matchPath('/entry/:id', location.pathname)

  const handleDateStartClick = (e) => {
    if (e.target.value) {
      localStorage.setItem('date_start', e.target.value) // Store the selected date in localStorage
      setEntryFilter({ ...entryFilter, 'date_start': e.target.value })
    } else {
      localStorage.removeItem('date_start') // Remove the item from localStorage if no date is selected
      const newFilter = { ...entryFilter }
      delete newFilter.date_start
      setEntryFilter(newFilter)
    }
  }
  const handleDateEndClick = (e) => {
    if (e.target.value) {
      localStorage.setItem('date_end', e.target.value) // Store the selected date in localStorage
      setEntryFilter({ ...entryFilter, 'date_end': e.target.value })
    } else {
      localStorage.removeItem('date_end') // Remove the item from localStorage if no date is selected
      const newFilter = { ...entryFilter }
      delete newFilter.date_end
      setEntryFilter(newFilter)
    }
  }

  const handleLastMonthClick = () => {
    const date_end = entryFilter.date_end ? new Date(entryFilter.date_end) : new Date()
    date_end.setDate(0)
    const date_start = new Date(date_end.getFullYear(), date_end.getMonth(), 1)
    setEntryFilter({
      ...entryFilter,
      date_start: date_start.toLocaleDateString('en-CA').split('T')[0],
      date_end: date_end.toLocaleDateString('en-CA').split('T')[0],
    })
    localStorage.setItem('date_start', date_start.toLocaleDateString('en-CA').split('T')[0])
    localStorage.setItem('date_end', date_end.toLocaleDateString('en-CA').split('T')[0])
  }

  const handleNextMonthClick = () => {
    const date_end = entryFilter.date_end ? new Date(entryFilter.date_end) : new Date()
    date_end.setMonth(date_end.getMonth() + 2)
    date_end.setDate(0)
    const date_start = new Date(date_end.getFullYear(), date_end.getMonth(),
        1)
    setEntryFilter({
      ...entryFilter,
      date_start: date_start.toLocaleDateString('en-CA').split('T')[0],
      date_end: date_end.toLocaleDateString('en-CA').split('T')[0],
    })
    localStorage.setItem('date_start', date_start.toLocaleDateString('en-CA').split('T')[0])
    localStorage.setItem('date_end', date_end.toLocaleDateString('en-CA').split('T')[0])
  }

  const handleNearestOneMonthClick = () => {
    const date_end = new Date()
    const date_start = new Date(date_end.getFullYear(), date_end.getMonth() - 1, date_end.getDate())
    setEntryFilter({
      ...entryFilter,
      date_start: date_start.toLocaleDateString('en-CA').split('T')[0],
      date_end: date_end.toLocaleDateString('en-CA').split('T')[0],
    })
    localStorage.setItem('date_start', date_start.toLocaleDateString('en-CA').split('T')[0])
    localStorage.setItem('date_end', date_end.toLocaleDateString('en-CA').split('T')[0])
  }

  return (
    <Box
      sx={{
        width: '400px',
        flexShrink: 0,
        position: 'sticky',
        top: '150px',
        alignSelf: 'flex-start',
        maxHeight: 'calc(100vh - 150px)',
        overflow: 'auto',
      }}
    >
      {match ?
        <EntryEdit id={match.params.id}/>
         :
        <>
          <Paper
            elevation={0}
            sx={{
              mb: 1.5,
              mx: 1,
              overflow: 'hidden',
              borderRadius: 2,
              border: '1px solid',
              borderColor: 'divider',
              bgcolor: 'background.paper',
            }}
          >
            <Box
              sx={{
                px: 2,
                py: 1.25,
                display: 'flex',
                alignItems: 'center',
                gap: 1.25,
                bgcolor: 'primary.main',
                color: 'primary.contrastText',
              }}
            >
              <EventIcon sx={{ fontSize: 18 }} />
              <Typography variant="subtitle2" fontWeight={600}>
                日期筛选
              </Typography>
            </Box>

            <Stack sx={{ p: 2, background: 'linear-gradient(180deg, rgba(102, 126, 234, 0.08) 0%, rgba(118, 75, 162, 0.05) 100%)' }} spacing={2}>
              <Stack direction="row" spacing={2}>
                <TextField
                  type="date"
                  fullWidth
                  label="起始"
                  value={entryFilter.date_start}
                  onChange={handleDateStartClick}
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  sx={{
                    '& .MuiInputBase-root': {
                      borderRadius: 2,
                    },
                  }}
                />
                <TextField
                  type="date"
                  fullWidth
                  label="结束"
                  value={entryFilter.date_end}
                  onChange={handleDateEndClick}
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  sx={{
                    '& .MuiInputBase-root': {
                      borderRadius: 2,
                    },
                  }}
                />
              </Stack>

              <Stack direction="row" spacing={1}>
                <Button
                  variant="outlined"
                  size="small"
                  fullWidth
                  startIcon={<ChevronLeftIcon />}
                  onClick={handleLastMonthClick}
                  sx={{
                    borderRadius: 2,
                    textTransform: 'none',
                    py: 0.75,
                    fontSize: '0.8rem',
                  }}
                >
                  上月
                </Button>
                <Button
                  variant="outlined"
                  size="small"
                  fullWidth
                  endIcon={<ChevronRightIcon />}
                  onClick={handleNextMonthClick}
                  sx={{
                    borderRadius: 2,
                    textTransform: 'none',
                    py: 0.75,
                    fontSize: '0.8rem',
                  }}
                >
                  下月
                </Button>
                <Button
                  variant="outlined"
                  size="small"
                  fullWidth
                  onClick={handleNearestOneMonthClick}
                  sx={{
                    borderRadius: 2,
                    textTransform: 'none',
                    py: 0.75,
                    fontSize: '0.8rem',
                  }}
                >
                  最近一个月
                </Button>
              </Stack>
            </Stack>
          </Paper>
          <Paper
            elevation={0}
            sx={{
              mx: 1,
              overflow: 'hidden',
              borderRadius: 2,
              border: '1px solid',
              borderColor: 'divider',
              bgcolor: 'background.paper',
            }}
          >
            <Box
              sx={{
                px: 2,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                bgcolor: 'success.main',
                color: 'success.contrastText',
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, py: 1.25 }}>
                <CategoryIcon sx={{ fontSize: 18 }} />
                <Typography variant="subtitle2" fontWeight={600}>
                  类别筛选
                </Typography>
              </Box>
              {entryFilter.categories && entryFilter.categories.length > 0 && (
                <Button
                  size="small"
                  startIcon={<ClearIcon sx={{ fontSize: 16 }} />}
                  onClick={() => setEntryFilter({ ...entryFilter, categories: [] })}
                  sx={{
                    color: 'inherit',
                    bgcolor: 'rgba(255,255,255,0.15)',
                    borderRadius: 2,
                    textTransform: 'none',
                    height: 30,
                    '&:hover': {
                      bgcolor: 'rgba(255,255,255,0.25)',
                    },
                  }}
                >
                  清除
                </Button>
              )}
            </Box>

            {categories && categories.length > 0 && (
              <List sx={{ p: 1.5, background: 'linear-gradient(180deg, rgba(17, 153, 142, 0.08) 0%, rgba(56, 239, 125, 0.05) 100%)' }}>
                {categories.map((category) => (
                  <CategoryItem item={category} />
                ))}
              </List>
            )}
          </Paper>
        </>}
    </Box>

  )
}
